import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=70167d4a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70167d4a')) {
      api.createRecord('70167d4a', component.options)
    } else {
      api.reload('70167d4a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=70167d4a&", function () {
      api.rerender('70167d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GbeC5qQzx6Xf/JS/comp/FavElement.vue"
export default component.exports